import { gql } from '@apollo/client';
import { ColumnConfigForExport } from './generateSlaSummaryDownloadReport';

export const GENERATE_SLA_SUMMARY_DOWNLOAD_REPORT_FOR_DSP = gql`
    mutation GenerateSlaSummaryDownloadReportForDsp(
        $arrivalDateStart: String!
        $arrivalDateEnd: String!
        $warehouseIds: [Long!]
        $hubId: Long
        $dspIds: [Long!]
        $areaIds: [Long!]
        $driverIds: [Long!]
        $cityNames: [String!]
        $arrivalPointType: Int!
        $dimension: String
        $columnConfig: [ColumnConfigForExportInput!]!
        $timezone: String
        $sortBy: String
        $sortDirection: String
    ) {
        generateSlaSummaryDownloadReportForDsp(
            arrivalDateStart: $arrivalDateStart
            arrivalDateEnd: $arrivalDateEnd
            warehouseIds: $warehouseIds
            hubId: $hubId
            dspIds: $dspIds
            areaIds: $areaIds
            driverIds: $driverIds
            cityNames: $cityNames
            arrivalPointType: $arrivalPointType
            dimension: $dimension
            columnConfig: $columnConfig
            timezone: $timezone
            sortBy: $sortBy
            sortDirection: $sortDirection
        )
    }
`;

export interface GenerateSlaSummaryDownloadReportForDspVariables {
    arrivalDateStart: string;
    arrivalDateEnd: string;
    warehouseIds?: number[] | null;
    hubId?: number | null;
    dspIds?: number[] | null;
    areaIds?: number[] | null;
    driverIds?: number[] | null;
    cityNames?: string[] | null;
    arrivalPointType: number;
    dimension?: string | null;
    columnConfig: ColumnConfigForExport[];
    timezone?: string | null;
    sortBy?: string | null;
    sortDirection?: string | null;
}

export interface GenerateSlaSummaryDownloadReportForDspResponse {
    generateSlaSummaryDownloadReportForDsp: string;
}
